import React, { useMemo, useState } from "react";
import { InputSelectBox, InputSelectBoxParams } from "../../../common/input/InputSelectBox";
import { LabelValueSet } from "../../../../../domain/utility/LabelValueSet";
import { userAccountRoleList } from "../../../../../domain/user/account/UserAccountRole";

export const UserAccountRoleSelector = React.memo(function UserAccountRoleSelector(props: UserAccountRoleSelectorProps) {
    const { whenUserAccountRoleChanged, hasError } = props;

    const [currentUserAccountRole, setCurrentUserAccountRole] = useState("");

    const inputProps: InputSelectBoxParams = useMemo(() => {
        const values = [new LabelValueSet("- 未選択 -", ""), ...userAccountRoleList];

        return {
            value: currentUserAccountRole,
            list: values,
            handleSelectBoxChanged: (value: string) => {
                setCurrentUserAccountRole(value);
                whenUserAccountRoleChanged(value);
            },
            hasError: hasError
        };
    }, [currentUserAccountRole, hasError, whenUserAccountRoleChanged]);

    return (
        <div>
            <InputSelectBox {...inputProps} />
        </div>
    );
});

export type UserAccountRoleSelectorProps = {
    whenUserAccountRoleChanged: (userAccountRole: string) => void;
    hasError?: boolean
};
